module.exports = __webpack_public_path__ + "media/demo2-jp.aa7e4e86.mp4";